import React from "react";

const BoxServiceComponent = ({ title, icon }) => {
  return (
    <div className="box-service">
      <img className="box-service-icon" src={icon} alt="" />
      <h6 className="box-service-title">{title}</h6>
    </div>
  );
};

export default BoxServiceComponent;
